export default __webpack_public_path__ + "static/media/arrow-icon.874e178e.svg";